<template>
	<div>
		<ContextMenu
			:menu-items="menuItems"
			:selected="sortDir"
			:launcher="launcher"
			:hide-icon="true"
			:show-arrow="false"
			:menu-offset="8"
		>
			<template #toggle>
				<Icon
					:icon-name="iconName"
					size="lg"
				/>
			</template>
		</ContextMenu>
	</div>
</template>
<script>
import ContextMenu from '../context-menu/ContextMenu';
import { bus } from '@videotools/js/events';
import { mapGetters } from 'vuex';

export default {
	name:       'SortButton',
	components: { ContextMenu },
	props:      {
		sortDir: {
			type:    String,
			default: 'desc',
		},
		customMenuItems: {
			type: Array,
		},
		includeIqScoreSorting: {
			type:    Boolean,
			default: false,
		},
	},
	computed: {
		...mapGetters({
			isMobileWebApp: 'app/isMobileWebApp',
		}),
		menuItems() {
			if (this.customMenuItems) return this.customMenuItems;

			let items = [
				{
					id:      'desc',
					label:   this.transUcfirst('commons.newest_first'),
					icon:    'sort-descending',
					handler: this.handleSortDesc,
				},
				{
					id:      'asc',
					label:   this.transUcfirst('commons.oldest_first'),
					icon:    'sort-ascending',
					handler: this.handleSortAsc,
				},
			];

			if (this.includeIqScoreSorting) {
				items = [...items, ...[{
					id:      'score-desc',
					label:   this.transUcfirst('commons.score_desc'),
					icon:    'sort-descending',
					handler: this.handleSortScoreDesc,
				},
				{
					id:      'score-asc',
					label:   this.transUcfirst('commons.score_asc'),
					icon:    'sort-ascending',
					handler: this.handleSortScoreAsc,
				}]];
			}

			return items;
		},
		iconName() {
			return this.menuItems.find(item => item.id === this.sortDir)?.icon;
		},
		launcher() {
			if (this.isMobileWebApp) {
				return () => {
					bus.publish('context-menu-mobile:open', {
						menuItems: this.menuItems,
						title:     this.transUcfirst('commons.sort_clips'),
						selected:  this.sortDir,
						hideIcon:  true,
					});
				};
			}

			return null;
		},
	},
	methods: {
		handleSortAsc() {
			this.$emit('sort-updated', 'timestamp', 'asc');
		},
		handleSortDesc() {
			this.$emit('sort-updated', 'timestamp', 'desc');
		},
		handleSortScoreAsc() {
			this.$emit('sort-updated', 'score', 'asc');
		},
		handleSortScoreDesc() {
			this.$emit('sort-updated', 'score', 'desc');
		},
	},
};
</script>

<style lang="scss" scoped>

</style>
